import Pusher from 'pusher-js';

// Initialize Pusher
const pusher = new Pusher('00112b3637fb6777810c', {
  cluster: 'eu', // Replace with your Pusher cluster
  encrypted: true,
});

// Export the Pusher instance
export default pusher;


